export default __webpack_public_path__ + "static/media/raaginder1.814dae89.jpeg";